import { matchPath, useLocation } from 'react-router-dom';

import { useUIStore } from '@/app/model';
import { useIsMobile } from '@/hooks/ui/useMediaQuery';
import { MobileBottomNav } from '@/features/tasks/mobile-bottom-nav/MobileBottomNav';
import { SideMenu } from '@/features/tasks/mobile-menu/SideMenu';

const ROUTES_WITHOUT_NAV = [
  { path: '/tools/:toolId', end: true },
  { path: '/tasks-new', end: true },
  { path: '/tasks-new/:id', end: true },
  // Дашборд /projects рисует собственный нижний navbar (Пульс/Время/Воронка/
  // Планирование/Ещё); пункты общего футера доступны в его шите «Ещё».
  { path: '/projects', end: true },
  // Справочники — полноэкранная таблица со своим футером; фиксированный
  // bottom-nav перекрыл бы её.
  { path: '/directories/:type', end: true },
  // Карточка контакта несёт собственную нижнюю панель вкладок (Контакт,
  // Покупки, звонок, Оплаты, Чат) — общий футер встал бы поверх неё.
  { path: '/contacts/:id', end: true },
  // Карточки сделки и лида — по той же причине: своя нижняя навигация
  // (Сделка, Покупки, FAB, Чат, Ещё).
  { path: '/deals/:id', end: true },
  { path: '/leads/:id', end: true },
];

export function MobileNavigation() {
  const isCalendarOpen = useUIStore((state) => state.isCalendarOpen);
  const isMobile = useIsMobile();
  const { pathname } = useLocation();

  const isNavDisabled = ROUTES_WITHOUT_NAV.some((route) =>
    matchPath(route, pathname)
  );

  if (!isMobile || isCalendarOpen) {
    return null;
  }

  return (
    <>
      {!isNavDisabled && <MobileBottomNav />}
      <SideMenu />
    </>
  );
}
